<div class="functie-overzicht">
  <div class="functie-overzicht__container" *ngIf="cmsContent">
    <div class="functie-overzicht__search-container">
      <div class="functie-overzicht__search">
        <input
          (keyup.ENTER)="search(query)"
          [(ngModel)]="query"
          [placeholder]="
            isMobile
              ? ('functie-overzicht-page.searchPlaceholderMobile' | content)
              : ('functie-overzicht-page.searchPlaceholder' | content)
          "
          class="functie-overzicht__search-input"
          type="text"
          (focus)="hideCompareDialog(true)"
          (focusout)="
            minimizeCompare ? hideCompareDialog(true) : hideCompareDialog(false)
          "
        />

        <button
          (click)="search(query)"
          class="functie-overzicht__search-input-button"
        >
          <mat-icon>search</mat-icon>
        </button>
      </div>
    </div>

    <div class="functie-overzicht__container--background-image">
      <img
        src="/assets/images/018222.2362 - Zorginspirator.nl -  headers 2600x1200 sRGB - Zoek een functie in de zorg.jpg"
        alt="Zorginspirator"
      />
    </div>
  </div>

  <div class="functie-overzicht__grid" *ngIf="cmsContent">
    <h1>{{ cmsContent.title }}</h1>
    <div
      class="functie-overzicht__context-outlet"
      [innerHTML]="cmsContent.description"
    ></div>

    <p style="margin-block: 0;"><strong>Snelle filters</strong></p>
    <div class="functie-overzicht__quick-filters">
      <div
        *ngFor="let q of quickFilters"
        (click)="selectQuickFilter(q)"
        [class.functie-overzicht__quick-filter-item--selected]="selectedQuickFilter === q"
        class="functie-overzicht__quick-filter-item"
      >
        {{ q }}
      </div>
    </div>

    <div class="functie-overzicht__active-filters" *ngIf="hasActiveFilters">
      <app-filter-chips
        [filterState]="filterState"
        (filterStateChange)="handleFilterStateChange($event)"
      >
      </app-filter-chips>
    </div>

    <div class="functie-overzicht__sort-container">
      <div class="functie-overzicht__result-button-container">
        <app-filter
          mode="functie"
          subset="zorg"
          [filterState]="filterState"
          (filtersLoaded)="handleFiltersLoaded($event)"
          (filterStateChange)="handleFilterStateChange($event)"
          [total]="total"
        >
        </app-filter>
      </div>

      <div class="functie-overzicht__sort">
        <mat-form-field class="full-width" appearance="standard">
          <mat-select
            data-cy="selecteerSortering"
            [placeholder]="'functie-overzicht-page.sort' | content"
            [value]="currentSort"
            (selectionChange)="sort($event.value)"
          >
            <ng-container *ngIf="showRelevanceSort">
              <mat-option value="rel" data-cy="sorteerRelevance">
                {{ "functie-overzicht-page.sortOn" | content }}
                <span class="functie-overzicht__sort-option-strong">
                  {{ "functie-overzicht-page.sortOnRelevance" | content }}
                </span>
              </mat-option>
            </ng-container>

            <ng-container *ngIf="showNameSort">
              <mat-option value="naam:asc" data-cy="sorteerNameAsc">
                {{ "functie-overzicht-page.sortOn" | content }}
                <span class="functie-overzicht__sort-option-strong">
                  {{ "functie-overzicht-page.sortOnNameAsc" | content }}
                </span>
              </mat-option>
              <mat-option value="naam:desc" data-cy="sorteerNameDesc">
                {{ "functie-overzicht-page.sortOn" | content }}
                <span class="functie-overzicht__sort-option-strong">
                  {{ "functie-overzicht-page.sortOnNameDesc" | content }}
                </span>
              </mat-option>
            </ng-container>

            <ng-container *ngIf="showMatchPercentage">
              <mat-option value="match:asc" data-cy="sorteerMatchAsc">
                {{ "functie-overzicht-page.sortOn" | content }}
                <span class="functie-overzicht__sort-option-strong">
                  {{ "functie-overzicht-page.sortOnMatchAsc" | content }}
                </span>
              </mat-option>
              <mat-option value="match:desc" data-cy="sorteerMatchDesc">
                {{ "functie-overzicht-page.sortOn" | content }}
                <span class="functie-overzicht__sort-option-strong">
                  {{ "functie-overzicht-page.sortOnMatchDesc" | content }}
                </span>
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
    </div>
    </div>

    <div>
      Resultaat: {{total}} functies
    </div>
    <app-functie-rooster
      [mode]="FunctieCardEnum.DEFAULT"
      [functies]="functies"
      [loading]="loading"
      (getMore)="getMore()"
      [showMatchPercentage]="showMatchPercentage"
      (sort)="sort($event)"
    >
    </app-functie-rooster>
  </div>

  <app-compare-dialog
    #compareDialog
    [minimized]="this.minimizeCompare"
    (minimizedEvent)="hideCompareDialog($event)"
  >
  </app-compare-dialog>
</div>
